import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@service/core/auth.service';
import { ServicosService } from '@service/core/servicos.service';
import { Observable} from 'rxjs';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, shareReplay, switchMap } from 'rxjs/operators';
import { BaseService } from './base.service';

@Injectable()
export class RecursosHumanosService extends BaseService {

  private baseUrl: string;

  constructor(
    public http: HttpClient,
    public servicos: ServicosService,
    protected auth: AuthService) {
    super(http);
    this.servicos.buscarUrls().subscribe(data => (this.baseUrl = `${data.urlBaseApiBasi}/v1/rh`));
  }

  protected handleError(error: any, callback: () => Observable<any>) {
    console.error(error);
    if (error.status === 401) { // Token expired
      return this.auth.refreshToken().pipe(
        switchMap((res: any) => {
          return callback();
        }),
        catchError(err => (ErrorObservable.create(err)))
      );
    } else {
      return ErrorObservable.create(error);
    }
  }

  public findAllEntidade(): Observable<Object | Entidade[]> {
    const url = `${this.baseUrl}/entidades`;
    return this.http
      .get(url, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .pipe(
        shareReplay(1), // Cache
        catchError(err => this.handleError(err, () => this.findAllEntidade()))
      );
  }

  public findUnidade(idUnidade: number): Observable<any> {
    const url = `${this.baseUrl}/unidades/${idUnidade}`;
    return this.http
      .get(url, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .pipe(
        shareReplay(1), // Cache
        catchError(err => this.handleError(err, () => this.findUnidade(idUnidade)))
      );
  }

  private handleFindColabodoresError(err: any, login: string): Observable<any> {
    console.warn(`Não foi possível consultar os dados do usuário "${login}" na API de Recursos Humanos.`);
    return new Observable<Colaborador[]>(
      observer => {
        const empty: Colaborador[] = [];
        observer.next(empty);
      }
    );
  }

  public getColaboradorByLogin(login: string): Observable<Colaborador>  {
    return super.getColaboradorByLogin(login, null, this.servicos);
  }

  public findColaboradoresByNome(filtro: string): Observable<Colaborador[]> {
    const url = `${this.baseUrl}/colaboradores/${filtro}/`;
    return this.http
      .get(url, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .pipe(
        shareReplay(1), // Cache
        catchError(err => this.handleFindColabodoresError(err, filtro))
      );
  }

  public findColaboradoresUnidade(idUnidade: number): Observable<Object | Colaborador[]> {
    const url = `${this.baseUrl}/unidades/${idUnidade}/colaboradores/`;
    return this.http
      .get(url, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .pipe(
        shareReplay(1), // Cache
        catchError(err => this.handleError(err, () => this.findColaboradoresUnidade(idUnidade)))
      );
  }
}

export interface Unidade {
  idUnidade: number;
  unidade: string;
}

export interface UsuarioLogado {
  login: string;
  nome: string;
  idUnidade: number;
  email: string;
}

export interface Entidade {
  idEntidade: number;
  entidade: string;
  unidades: Unidade[];
}

export interface Colaborador {
  cpf: string;
  cargo: string;
  fax?: string;
  entidade_origem?: string;
  tipo?: string;
  superior?: string;
  sala_andar?: string;
  unidade?: string;
  sexo?: string;
  gerencia?: string;
  funcionario: string;
  telefone?: string;
  entidade?: string;
  matricula?: string;
  dia_Mes_Nascimento?: string;
  login: string;
  confianca?: string;
  localidade?: string;
  email: string;
  idUnidade?: number;
  idEntidade?: number;
  idLocalidade?: number;
}



// WEBPACK FOOTER //
// ./src/app/service/core/recursos-humanos.service.ts